var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"l-inline l-gap-0"},_vm._l((_vm.progressRange),function(item){return _c('span',{key:item,staticClass:"progress-dot",class:{
            'progress-dot--checked': item > _vm.max - _vm.value,
        }})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }